export interface IProps {}

export interface InstitutionContact {
  id: number;
  name: string;
  address: string;
  phones: string[];
  emails: string[];
  website: string;
  county: string;
  city: string;
}

interface InstitutionRecord {
  id: number;
  attributes: {
    title?: string;
    address?: string;
    phone1?: string;
    email?: string;
    website?: string;
    county?: string;
    city?: string;
  };
}

export const mapInstitutionContact = ({ id, attributes }: InstitutionRecord): InstitutionContact => ({
  id,
  name: attributes.title?.trim() || "",
  address: attributes.address?.trim() || "",
  phones: attributes.phone1?.split(/[,;\n]+/).map(value => value.trim()).filter(Boolean) || [],
  emails: attributes.email?.split(/[,;\s]+/).filter(Boolean) || [],
  website: attributes.website?.trim() || "",
  county: attributes.county?.trim() || "",
  city: attributes.city?.trim() || "",
});
